import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CloseIcon from "@mui/icons-material/Close";
import InputField from "../../../common/CustomInputField";
import SelectField from "../../../common/SelectField";
import RadioButton from "../../../common/RadioButton";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "../../../common/styles/common.scss";
import { relationships, getAge } from "../../../constants/constants";
import { SecondaryButton } from "../../../common/Buttons";

import "../../../components/yourAssets/FT/familyTree.scss";

import { style } from "../../../common/common";
import toast, { Toaster } from "react-hot-toast";
import {
  addFamilyMember,
  getMarriageTypes,
  uploadProfilePicture,
} from "../../../services/yourAssets/FamilyTreeServices";

import {
  addNewFamilyMember,
  getFamilyMembersList,
  setFamilyMembersList,
  updateFamilyMember,
} from "../../../utils/FTUtilities";
import TextField from "../../../common/TextField";
import { useTranslation } from "react-i18next";
import { getKeyFromText, setFTGraphCheck } from "../../../utils/Utilities";
import RelationPopup from "../../../common/popup/RelationPopup";

const AddMemberModal = (props) => {
  const popupTextKeys = {
    spouse: "add-spouse",
    partnerNotMarried: "add-partner-not-married",
    Child: "add-child",
    childLt18: "add-child-under-18",
    grandChild: "add-grand-child",
  };
  const [tempFormikInstance, setFormikInstance] = useState({});
  const [showRelationPopup, setShowRelationPopup] = useState(false);
  const [relationPopupText, setRelationPopupText] = useState("");
  const [memberObj, setMemberObj] = useState({});
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const {
    open,
    handleClose,
    handleComplicatedRelation,
    currentNode,
    refresh,
    complicatedRelation,
    userId,
  } = props;

  const handleOpenRelationPopup = () => {
    setShowRelationPopup(true);
  };

  const handleCloseRelationPopup = () => {
    setShowRelationPopup(false);
  };

  const containsNumber = (str) => {
    return /\d/.test(str);
  };
  const containSpecialChar = (str) => {
    return /[-!$%^&*()£_+|~=`{}\[\]:\/;<>?,.@#]/.test(str);
  };

  const checkRelation = (relation) => {
    switch (relation) {
      case t("partner-male"):
        return true;
      case t("partner-female"):
        return true;
      case t("ex-partner-male"):
        return true;
      case t("ex-partner-female"):
        return true;
      default:
        return false;
    }
  };
  const relationshipSchema = Yup.object().shape({
    name: Yup.string().required(t("required")),
    gender: Yup.string().required(t("required")),
    // when("name", {
    // is: (name) => checkRelation(name),
    // then: Yup.string().test(
    //   "valid-gender",
    //   t("invalid-gender"),
    //   function (values) {
    //     if (values === currentNode.gender) return false;
    //     return true;
    //   }
    // ),
    //}),
  });
  const modalSchema = Yup.object().shape({
    firstName: Yup.string()
      .label("First Name")
      .required(t("required"))
      .max(20, t("first-name-max"))
      .min(3, t("first-name-min"))
      .test(
        "First Name",
        t("first-name-invalid"),
        (value) => !containsNumber(value)
      ),
    lastName: Yup.string()
      .label("Last Name")
      .required(t("required"))
      .max(20, t("last-name-max"))
      .min(3, t("last-name-min"))
      .test(
        "Last Name",
        t("last-name-invalid"),
        (value) => !containsNumber(value)
      ),
    relationship: relationshipSchema,

    dateOfBirth: Yup.string()
      .label("Date of birth")

      .when("isChild", {
        is: true,
        then: Yup.string().required(t("required")),
      }),
    address: Yup.string()
      .label("Address")
      .max(50, t("address-max-50"))
      .min(3, t("address-min")),
    isChild: Yup.boolean(),
  });
  const [initialValues, setInitialValues] = useState({});
  const [marriageContractTypes, setMarriageContractTypes] = useState([]);
  const [parentError, setParentError] = useState("");
  const [relationshipError, setRelationshipError] = useState("");
  const [marriageContractError, setMarriageContractError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [profilePicture, setProfilePicture] = useState("");
  const [profilePictureName, setProfilePictureName] = useState("");
  const [partnersList, setPartnersList] = useState([]);
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    let nodeList = getFamilyMembersList();
    let array = [];
    let initialValues = {
      firstName: "",
      lastName: "",
      relationship: {},
      parent: {},
      dateOfBirth: "",
      personPassedAway: false,
      address: "",
      personLives: false,
      profilePicture: "",
      marriageContract: "",
      isChild: false,
    };

    for (let i = 0; i < currentNode?.pids?.length; i++) {
      const elementI = currentNode?.pids[i];
      for (let i = 0; i < nodeList.length; i++) {
        const elementJ = nodeList[i];
        if (elementI === elementJ.id) {
          array.push(elementJ);
        }
      }
    }
    setInitialValues(initialValues);
    setPartnersList(array);

    const getMarriageTypeList = async () => {
      let result = await getMarriageTypes();

      if (result?.success) {
        setMarriageContractTypes([...result?.payLoad]);
      }
    };
    getMarriageTypeList();
  }, [currentNode]);

  const handleChange = (event, key, formik) => {
    let value;
    if (["relationship", "parent", "marriageType"].includes(key)) {
      value = event;
    } else if (key === "profilePicture") {
      value = event.target.files[0];
    } else {
      value = event.target.value || "";
    }

    if (key === "firstName") {
      formik.setFieldValue("firstName", value);
    } else if (key === "lastName") {
      formik.setFieldValue("lastName", value);
    } else if (key === "relationship") {
      if (value.name === t("son") || value.name === t("daughter")) {
        formik.setFieldValue("isChild", true);
      } else formik.setFieldValue("isChild", false);
      formik.setFieldValue("relationship", value);
    } else if (key === "parent") {
      formik.setFieldValue("parent", value);
    } else if (key === "dateOfBirth") {
      console.log("Date of birth:", value); // Add this console log statement
      formik.setFieldValue("dateOfBirth", value);
    } else if (key === "personPassedAway") {
      formik.setFieldValue("personPassedAway", !formik.values.personPassedAway);
    } else if (key === "address") {
      formik.setFieldValue("address", value);
    } else if (key === "personLives") {
      formik.setFieldValue("personLives", !formik.values.personLives);
    } else if (key === "profilePicture") {
      formik.setFieldValue("profilePicture", value);
    } else if (key === "marriageType") {
      formik.setFieldValue("marriageContract", value);
    }

    setParentError("");
    // setRelationshipError("");
    setFirstNameError("");
  };

  const handleSubmit = async (values, { setFieldError }) => {
    // if (formik.isValid && Object.keys(formik.touched).length > 0) {
    values = {
      ...values,
      relationship: {
        ...values.relationship,
        //name: t(getKeyFromText(values.relationship.name)),
        name: relationships.find((re) => re.id == values.relationship.id)?.name,
      },
    };
    let nodeList = getFamilyMembersList();
    let {
      firstName,
      lastName,
      personPassedAway,
      address,
      personLives,
      dateOfBirth,
      relationship,
      parent,
      marriageContract,
    } = values;
    // formik?.values;

    let pictureId = "";
    let pictureName = "";
    let maxId = Math.max(...nodeList.map((item) => item.id));
    // if (Object.keys(relationship).length > 0) {
    let newObj = {
      id: maxId + 1,
      firstName,
      lastName,
      pictureId,
      pictureName,
      relationship: relationship.name,
      marriageTypeId: marriageContract.marriageTypeId,
      gender: relationship.gender === "other" ? "female" : relationship.gender,
      address,
      personLives,
      dateOfBirth,
      complicatedRelation,
    };

    newObj.isDead = personPassedAway;
    let rootNode;
    for (let i = 0; i < nodeList.length; i++) {
      const element = nodeList[i];
      if (element.id === currentNode.id) {
        rootNode = element;
      }
    }
    let dispatcherObj = {
      newObj,
      currentNodeId: rootNode.id,
    };

    if (["Son", "Daughter"].includes(relationship.name)) {
      if (currentNode.gender === "male") {
        newObj.mid = parent.id;
      } else {
        newObj.fid = parent.id;
      }
      if (rootNode.gender === "female" || rootNode.gender === "other") {
        newObj.mid = rootNode.id;
      } else {
        newObj.fid = rootNode.id;
      }
      dispatcherObj.type = "childrelation";
    } else if (relationship?.name?.includes("Partner")) {
      newObj.pids = [rootNode.id];
      if (relationship?.name?.includes("Ex")) {
        newObj.divorced = [rootNode.id];
      }
      dispatcherObj.type = "addpartner";
    } else if (["Father", "Mother"].includes(relationship?.name)) {
      if (
        (relationship.name === "Mother" && currentNode.mid !== null) ||
        (relationship.name === "Father" && currentNode.fid !== null)
      ) {
        toast.error(t("multiple-parents-err"));
        return;
      }
      dispatcherObj.type = "addparent";
    } else if (["Brother", "Sister"].includes(relationship?.name)) {
      dispatcherObj.type = "addsiblings";
    }
    let nodes = [];
    if (rootNode.id === 1 && rootNode.pids.length > 0) {
      nodes = nodeList.filter((node) => {
        let status =
          node.marriageTypeId === "bf5ca35b-62ac-4616-aba8-18319da10bd9" ||
          node.marriageTypeId === "bbd554ee-1a96-4cd5-b95e-cb3e82b8d050" ||
          node.marriageTypeId === "7b059c64-0ed2-4490-9266-6e2b72010555";
        return rootNode.pids.some((id) => {
          return node.id === id && status;
        });
      });
    }
    let registered = false;
    if (nodes?.length > 0) registered = true;

    let hasPartner = [];
    if (rootNode.id !== 1 && rootNode.pids.length > 0) {
      if (rootNode.divorced.length !== 0) {
        const array = rootNode.pids.filter((pid, i) => {
          return rootNode.divorced.some((id) => {
            return pid !== id;
          });
        });
        hasPartner = [...array];
      } else {
        hasPartner = [...rootNode.pids];
      }
    }
    if (
      ["Partner-Male", "Partner-Female"].includes(relationship.name) &&
      !newObj.marriageTypeId &&
      rootNode.id === 1
    ) {
      setMarriageContractError("Required");
    } else {
      if (
        !relationship.name.includes("Partner") ||
        relationship.name.includes("Ex") ||
        (rootNode.id !== 1 && hasPartner.length === 0) ||
        (rootNode.id === 1 && !registered) ||
        (rootNode.id === 1 &&
          registered &&
          marriageContract.name === "Non-Registered")
      ) {
        // if (Object.keys(formik.errors).length === 0) {
        // if (
        //   ["Son", "Daughter"].includes(relationship?.name) &&
        //   Object.keys(parent)?.length === 0 &&
        //   partnersList.length > 0
        // ) {
        //   setParentError("Required");
        // } else {
        if (
          // (rootNode?.pids.length === 0 &&
          //   ["Son", "Daughter"].includes(relationship?.name)) ||
          (rootNode?.mid &&
            rootNode?.fid &&
            rootNode?.id === 1 &&
            ["Father", "Mother"].includes(relationship?.name)) ||
          (rootNode?.fid === null &&
            rootNode?.mid === null &&
            ["Brother", "Sister"].includes(relationship?.name))
        ) {
          toast.error(t("cannot-add"));
        } else {
          addNewFamilyMember(newObj);
          updateFamilyMember(dispatcherObj);
          setFamilyMembersList(nodeList);
          setMemberObj(newObj);
          let popupTextKey = "";

          if (
            ["Daughter", "Son", "Partner-Female", "Partner-Male"].includes(
              relationship.name
            ) &&
            currentNode.id === 1
          ) {
            if (
              relationship.name === "Partner-Female" ||
              relationship.name === "Partner-Male"
            ) {
              if (
                newObj.marriageTypeId === "e3bd2c24-7628-46af-b1df-933f2a8f4bdd"
              ) {
                popupTextKey = popupTextKeys.partnerNotMarried;
              } else {
                popupTextKey = popupTextKeys.spouse;
              }
            } else if (
              relationship.name === "Daughter" ||
              relationship.name === "Son"
            ) {
              if (getAge(dateOfBirth) < 18) {
                console.log("Age is less than 18", getAge(dateOfBirth)); // Add this line to log the age
                popupTextKey = popupTextKeys.childLt18;
              } else {
                popupTextKey = popupTextKeys.Child;
              }
            }
            setRelationPopupText(popupTextKey);
            handleOpenRelationPopup();
          } else if (
            (currentNode.fid === 1 || currentNode.mid === 1) &&
            (relationship.name === "Daughter" || relationship.name === "Son")
          ) {
            popupTextKey = popupTextKeys.grandChild;
            setRelationPopupText(popupTextKey);
            handleOpenRelationPopup();
          } else {
            handleConfirm();
          }
        }
        // }
        // } else {
        //   setFirstNameError("Required");
        // }
      } else {
        // setRelationshipError(
        //   "More than one registered spouse is not allowed."
        // );
        setFieldError("relationship", {
          name: `${t("valid-reg-marriage-err")}`,
        });
      }
    }
    // }
    // else {
    // setRelationshipError("Required");
    // setFieldError(relationship, "Required");
    // if (!firstName) {
    //   setFirstNameError("Required");
    // }
    // }
    // }
    setFTGraphCheck(true);
  };
  const handleConfirm = async () => {
    setDisable(true);
    const nodeList = getFamilyMembersList();
    const newObj = { ...memberObj };
    if (profilePicture) {
      setLoading(true);
      let formData = new FormData();
      formData.append("FamilyTreeImage", profilePicture);
      let result = await uploadProfilePicture(userId, formData);
      if (result?.success) {
        newObj.pictureId = result?.payLoad?.familyTreeImageId;
        newObj.pictureName = result?.payLoad?.originalFilename;
        let lastNodeIndex = nodeList.length - 1;
        nodeList[lastNodeIndex].pictureId = result?.payLoad?.familyTreeImageId;
        nodeList[lastNodeIndex].pictureName = result?.payLoad?.originalFilename;

        // toast.success(t(getKeyFromText(result?.message)));
        await addFamilyMember(userId, nodeList);
        setProfilePicture("");
        setProfilePictureName("");
        setFirstNameError("");
        // setRelationshipError("");
        refresh();
        handleClose();
      } else {
        toast.error(t(getKeyFromText(result?.message).replaceAll(".", "")));
      }
      setLoading(false);
    } else {
      setLoading(true);
      await addFamilyMember(userId, nodeList);
      setProfilePicture("");
      setProfilePictureName("");
      setFirstNameError("");
      // setRelationshipError("");
      refresh();
      handleClose();
      setLoading(false);
    }
    handleCloseRelationPopup();
    setDisable(false);
  };

  const selectProfilePicture = (e) => {
    let file = e.target.files[0];
    setProfilePicture(file);
    setProfilePictureName(file.name);
  };

  const getRelationList = () => {
    let arr = [];
    relationships.slice(0, 10).forEach((relation) => {
      arr = [...arr, { ...relation, name: t(getKeyFromText(relation.name)) }];
    });
    return arr;
  };

  return (
    <>
      <Toaster />
      {showRelationPopup && (
        <RelationPopup
          open={showRelationPopup}
          relationPopupText={relationPopupText}
          handleClose={handleCloseRelationPopup}
          handleConfirm={handleConfirm}
          disable={disable}
        />
      )}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        className="add-member"
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Formik
          validationSchema={modalSchema}
          initialValues={initialValues}
          onSubmit={(values, { setFieldError }) => {
            !loading && handleSubmit(values, { setFieldError });
          }}
          enableReinitialize
        >
          {(formik) => {
            return (
              <Form>
                <Fade in={open}>
                  <Box sx={style}>
                    <Box
                      component="div"
                      className="header"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      padding="0px 10px"
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            height: "30px",
                            width: "30px",
                            marginRight: "10px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            padding: "0 5px",
                          }}
                        >
                          <img
                            src={`${currentNode?.profilePicture.replace(
                              ".png",
                              ".png"
                              // "-form.png"
                            )}`}
                            alt="member"
                            width="auto"
                            height="80%"
                            style={{
                              marginTop: "2px",
                            }}
                          />
                        </div>
                        <p>{t("add-member-heading")}</p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CloseIcon
                          onClick={handleClose}
                          sx={{ cursor: "pointer" }}
                        />
                      </div>
                    </Box>
                    <Box padding="0px 10px" sx={{ marginBottom: "20px" }}>
                      <SelectField
                        label={t("input-15")}
                        value={formik.values?.relationship?.name || ""}
                        onChange={(item) => {
                          handleChange(item, "relationship", formik);
                        }}
                        menuList={getRelationList()}
                      />
                      {(formik.errors?.relationship?.name ||
                        formik.errors?.relationship?.gender) && (
                        <p
                          style={{
                            fontSize: "10px",
                            color: "red",
                            margin: 0,
                          }}
                        >
                          {formik.errors?.relationship?.name
                            ? formik.errors?.relationship?.name
                            : formik.errors?.relationship?.gender}
                        </p>
                      )}
                      <TextField
                        label={t("input-1")}
                        value={formik.values.firstName}
                        onChange={(e) => {
                          handleChange(e, "firstName", formik);
                        }}
                        name="firstName"
                        error={
                          formik.errors.firstName && formik.touched.firstName
                            ? formik.errors.firstName
                            : ""
                        }
                      />
                      <TextField
                        label={t("input-10")}
                        value={formik.values.lastName}
                        onChange={(e) => {
                          handleChange(e, "lastName", formik);
                        }}
                        name="lastName"
                        error={
                          formik.errors.lastName && formik.touched.lastName
                            ? formik.errors.lastName
                            : ""
                        }
                      />
                      {["Son", "Daughter"].includes(
                        t(
                          formik.values?.relationship?.name &&
                            getKeyFromText(formik.values?.relationship?.name)
                        )
                      ) && partnersList?.length > 0 ? (
                        <SelectField
                          label={t("input-16")}
                          value={formik.values?.parent?.firstName || ""}
                          onChange={(item) => {
                            handleChange(item, "parent", formik);
                          }}
                          menuList={partnersList}
                          error={formik.errors}
                        />
                      ) : null}{" "}
                      {parentError && (
                        <p
                          style={{
                            fontSize: "10px",
                            color: "red",
                            margin: 0,
                          }}
                        >
                          {parentError}
                        </p>
                      )}
                      {[t("partner-male"), t("partner-female")].includes(
                        formik.values.relationship?.name
                      ) &&
                        currentNode?.id === 1 && (
                          <>
                            <SelectField
                              label={t("marriage-contract-type")}
                              value={
                                t(
                                  formik.values?.marriageContract
                                    ?.translationKey
                                ) || ""
                              }
                              onChange={(item) => {
                                setMarriageContractError("");
                                handleChange(item, "marriageType", formik);
                              }}
                              menuList={marriageContractTypes}
                              error={formik.errors}
                            />
                            {marriageContractError && (
                              <p
                                style={{
                                  fontSize: "10px",
                                  color: "red",
                                  margin: 0,
                                }}
                              >
                                {t(marriageContractError.toLocaleLowerCase())}
                              </p>
                            )}
                          </>
                        )}
                      <InputField
                        label={t("input-2")}
                        type="date"
                        dateFormatProp={"DD MM YYYY"}
                        // value={formik.values.dateOfBirth}
                        // onChange={(e) => {
                        //   handleChange(e, "dateOfBirth", formik);
                        // }}
                        value={formik.values.dateOfBirth}
                        onChange={(newValue) => {
                          formik.setFieldValue("dateOfBirth", newValue);
                        }}
                        name="dateOfBirth"
                        onFocus={(e) => (e.target.type = "date")}
                        // name="dateOfBirth"
                        error={
                          formik.errors.dateOfBirth &&
                          formik.touched.dateOfBirth
                            ? formik.errors.dateOfBirth
                            : ""
                        }
                      />
                      <RadioButton
                        name="personPassedAway"
                        id={1}
                        label={t("passed-away-txt")}
                        value={1}
                        checked={formik.values.personPassedAway}
                        onChange={(e) => {
                          handleChange(e, "personPassedAway", formik);
                        }}
                      />
                      <TextField
                        label={t("input-12")}
                        value={formik.values.address}
                        onChange={(e) => {
                          handleChange(e, "address", formik);
                        }}
                        name="address"
                        error={
                          formik.errors.address && formik.touched.address
                            ? formik.errors.address
                            : ""
                        }
                      />
                      <RadioButton
                        name="personLives"
                        id={2}
                        label={t("live-withYou-txt")}
                        value={2}
                        checked={formik.values.personLives}
                        onChange={(e) => {
                          handleChange(e, "personLives", formik);
                        }}
                      />
                      <InputField
                        label={t("input-18")}
                        onChange={selectProfilePicture}
                        name="profilePicture"
                        type="file"
                        docName={profilePictureName}
                        accept="image/png, image/gif, image/jpeg"
                      />
                      <div
                        style={{
                          width: "100%",
                          backgroundColor: complicatedRelation
                            ? "#DFC8DB"
                            : "#DEDEDE",
                          borderRadius: "25px",
                          padding: "5px 0px ",
                          fontSize: "0.9rem",
                          fontWeight: "400",
                          textAlign: "center",
                          marginTop: "10px",
                          color: complicatedRelation ? "#444561" : "#707070",
                        }}
                      >
                        <p
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={handleComplicatedRelation}
                          dangerouslySetInnerHTML={{
                            __html: t("input-14"),
                          }}
                        ></p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <SecondaryButton
                          type="submit"
                          title={t("save")}
                          bgColor="color.magentaLight2"
                          borderRadius="13px"
                          width="120px"
                          padding="8px 35px"
                          // marginLeft="20px"
                          click={formik.handleSubmit}
                          isLoading={loading}
                          textTransform="capitalize"
                          border="1px solid #dfc8db"
                        />
                      </div>
                    </Box>
                  </Box>
                </Fade>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

export default AddMemberModal;
